import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out after 1.5 seconds
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 1500);

    // Complete and unmount after fade animation
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 2000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
      data-testid="splash-screen"
    >
      {/* 3D OC Logo */}
      <img 
        src="/splash_logo.png" 
        alt="Officium Connect" 
        className="h-40 w-auto md:h-52"
      />

      {/* App Name */}
      <h1 className="mt-4 text-2xl md:text-3xl font-bold text-white tracking-tight">
        Officium Connect
      </h1>
      
      {/* Tagline */}
      <p className="mt-2 text-sm text-slate-400">
        Your Career, Our Mission
      </p>

      {/* Loading indicator */}
      <div className="mt-8 flex space-x-1.5">
        <div className="w-2 h-2 bg-[#3B82F6] rounded-full animate-bounce" style={{animationDelay: '0ms'}}></div>
        <div className="w-2 h-2 bg-[#3B82F6] rounded-full animate-bounce" style={{animationDelay: '150ms'}}></div>
        <div className="w-2 h-2 bg-[#3B82F6] rounded-full animate-bounce" style={{animationDelay: '300ms'}}></div>
      </div>
    </div>
  );
};

export default SplashScreen;
